<script lang="ts">
	import loadingIcon from "@core/assets/icons/loading-icon.svg?raw";
	import Arrow from "./Arrow.svelte";
	import type { ButtonIcon } from "./ButtonIcon.js";
	import Icon from "./Icon.svelte";

	const { icon }: { icon: ButtonIcon } = $props();
</script>

{#if icon === "loading"}
	<Icon icon={loadingIcon} class="animate-spin size-5 md:size-8" />
{:else if icon === "arrow"}
	<Arrow class="size-5 md:size-8" />
{:else if icon === "none"}
	<span class="inline-block h-5 md:h-8"></span>
{:else if typeof icon === "function"}
	{@render icon()}
{/if}
